import axios, { ResponseType } from "axios";
import { toast } from "react-toastify";
import HelperService from "./HelperService";
import store from "../Redux/store";
import { removeFcmToken } from "../firebase";

// const BASE_URL = "https://devapi.falchionxeniaa.com/"
// const BASE_URL = "https://apiv2.myfxpos.com/"
const BASE_URL = process.env.REACT_APP_API_BASE_URL

interface PropData {
  action: string;
  body?: any;
  isFormData?: boolean;
  isShowError?: boolean;
  isHideToast?: boolean;
  id?: string;
  _file?: File;
  key?: string;
  btnId?: string;
  responseType?: ResponseType;
  signal?: AbortSignal;
  headers?: Record<string, string>;
}

let isGlobalErrorShown = false
let globalErrorTimeout: any = null
const WebService = {

  // postAPI(props: PropData) {
  //   return new Promise((resolve, reject) => {
  //     const bodyFormData = new URLSearchParams();
  //     for (let key in props.body) {
  //       bodyFormData.append(key, props.body[key]);
  //     }
  //     const headers = this.getHeaders()
  //     WebService.addLoader(props.btnId);
  //     axios.post(
  //       `${BASE_URL}${props.action}`,
  //       props.isFormData ? bodyFormData : props.body,
  //       { headers }
  //     )
  //       .then((response) => {
  //         resolve(response.data)
  //         if (!props.isHideToast) {
  //           toast.success(response.data.message);
  //         }

  //       }).catch((error) => {
  //         if (error?.response?.status === 401) {
  //           WebService.logout();
  //         }

  //         props.isShowError
  //           ? reject(error)
  //           : reject(WebService.errorHandler(error));
  //       }).finally(() => {
  //         WebService.removeLoader(props.btnId);
  //       })
  //   });
  // },



  postAPI(props: PropData) {
    return new Promise((resolve, reject) => {

      // ✅ Add timestamp to body
      const updatedBody = {
        ...props.body,
        timestamp: Date.now(), // or new Date().toISOString()
      };

      let finalBody: any;

      if (props.isFormData) {
        const bodyFormData = new URLSearchParams();

        for (let key in updatedBody) {
          bodyFormData.append(key, updatedBody[key]);
        }
        finalBody = bodyFormData;
      } else {
        finalBody = updatedBody;
      }

      const headers = this.getHeaders();

      WebService.addLoader(props.btnId);

      axios.post(
        `${BASE_URL}${props.action}`,
        finalBody,
        { headers, signal: props.signal }
      )
        .then((response) => {
          resolve(response.data);

          if (!props.isHideToast) {
            toast.success(response.data.message);
          }
        })
        .catch((error) => {
          if (axios.isCancel(error)) return;
          if (error?.response?.status === 401) {
            WebService.logout();
          }

          props.isShowError
            ? reject(error)
            : reject(WebService.errorHandler(error));
        })
        .finally(() => {
          WebService.removeLoader(props.btnId);
        });
    });
  },


  downloadFileAPI(props: PropData) {
    return new Promise((resolve, reject) => {
      const { body, isFormData, btnId, action } = props;
      const headers = this.getHeaders();
      const bodyFormData = new URLSearchParams();
      if (isFormData) {
        for (let key in body) {
          bodyFormData.append(key, body[key]);
        }
      }
      WebService.addLoader(btnId);
      axios.post(`${BASE_URL}${action}`, isFormData ? bodyFormData : body, {
        headers: {
          ...headers,
          Accept:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
        signal: props.signal,
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (axios.isCancel(error)) return;
          if (error?.response?.status === 401) {
            WebService.logout();
          }
          props.isShowError
            ? reject(error)
            : reject(WebService.errorHandler(error));
        })
        .finally(() => {
          WebService.removeLoader(btnId);
        });
    });
  },
  formaDataPostAPI(props: PropData) {
    return new Promise((resolve, reject) => {
      const bodyFormData = new FormData();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      const headers = this.getMultipartHeaders()
      WebService.addLoader(props.btnId);
      axios.post(
        `${BASE_URL}${props.action}`,
        props.isFormData ? bodyFormData : props.body,
        { headers, signal: props.signal }
      )
        .then((response) => {
          resolve(response.data)
          if (!props.isHideToast) {
            toast.success(response.data.message);
          }
        })
        .catch((error) => {
          if (axios.isCancel(error)) return;
          if (error?.response?.status === 401) {
            WebService.logout();
          }
          props.isShowError
            ? reject(error.response?.data?.message || "Something went wrong")
            : reject(WebService.errorHandler(error));
        })
        .finally(() => {
          WebService.removeLoader(props.btnId);
        });
    });
  },
  formaDataPutAPI(props: PropData) {
    return new Promise((resolve, reject) => {
      const bodyFormData = new FormData();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      const headers = this.getMultipartHeaders();
      WebService.addLoader(props.btnId);
      axios.put(
        `${BASE_URL}${props.action}`,
        props.isFormData ? bodyFormData : props.body,
        { headers, signal: props.signal }
      ).then((response) => {
        resolve(response.data)
        if (!props.isHideToast) {
          toast.success(response.data.message);
        }
      })
        .catch((error) => {
          if (axios.isCancel(error)) return;
          if (error?.response?.status === 401) {
            WebService.logout();
          }
          props.isShowError
            ? reject(error)
            : reject(WebService.errorHandler(error));
        })
        .finally(() => {
          WebService.removeLoader(props.btnId);
        });
    });
  },
  uploadAPI(props: PropData) {
    let formData = new FormData();
    if (props._file && props.key) {
      formData.append(props.key, props._file);
    }
    if (props.btnId) {
      WebService.addLoader(props.btnId);
    }
    return new Promise((resolve, reject) => {
      for (let key in props.body) {
        formData.append(key, props.body[key]);
      }
      const headers = this.getMultipartHeaders();
      axios.post(`${BASE_URL}${props.action}`, formData, { headers, signal: props.signal })
        .then((response) => {
          resolve(response.data)
          if (!props.isHideToast) {
            toast.success(response.data.message);
          }
        })
        .catch((error) => {
          if (axios.isCancel(error)) return;
          if (error?.response?.status === 401) {
            WebService.logout();
          }
          props.isShowError
            ? reject(WebService.errorHandler(error))
            : reject(error);
        })
        .finally(() => {
          if (props.btnId) {
            WebService.removeLoader(props.btnId);
          }
        });
    });
  },

  putAPI(props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = this.getHeaders();
      if (props.btnId) {
        WebService.addLoader(props.btnId);
      }
      axios
        .put(`${BASE_URL}${props.action}`, props.body, { headers, signal: props.signal })
        .then((response) => {
          if (!props.isHideToast) {
            toast.success(response.data.message);
          }
          resolve(response.data)
        })
        .catch((error) => {
          if (axios.isCancel(error)) return;
          if (error?.response?.status === 401) {
            WebService.logout();
          }
          props.isShowError
            ? reject(error)
            : reject(WebService.errorHandler(error))
        })
        .finally(() => {
          if (props.btnId) {
            WebService.removeLoader(props.btnId);
          }
        });
    });
  },

  beforeLoginAPI(props: PropData) {
    return new Promise((resolve, reject) => {
      const bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      const headers = {
        "Content-Type": "application/json",
      };
      if (props.btnId) {
        WebService.addLoader(props.btnId);
      }
      axios
        .post(
          `${BASE_URL}${props.action}`,
          props.isFormData ? bodyFormData : props.body,
          { headers, signal: props.signal }
        )
        .then((response) => {
          resolve(response.data)
          if (!props.isHideToast) {
            toast.success(response.data.message);
          }
        })
        .catch((error) => {
          if (axios.isCancel(error)) return;
          if (props.isShowError) {
            reject(WebService.errorHandler(error));
          } else {
            toast.error(error?.response?.data?.message);
            reject(error);
          }
        })
        .finally(() => {
          if (props.btnId) {
            WebService.removeLoader(props.btnId);
          }
        });
    });
  },
  beforeLoginPutAPI(props: PropData) {
    return new Promise((resolve, reject) => {
      const bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      const headers = {
        "Content-Type": "application/json",
      };
      if (props.btnId) {
        WebService.addLoader(props.btnId);
      }
      axios
        .put(
          `${BASE_URL}${props.action}`,
          props.isFormData ? bodyFormData : props.body,
          { headers, signal: props.signal }
        )
        .then((response) => {
          resolve(response.data)
          if (!props.isHideToast) {
            toast.success(response.data.message);
          }
        })
        .catch((error) => {
          if (axios.isCancel(error)) return;
          if (props.isShowError) {
            reject(WebService.errorHandler(error));
          } else {
            toast.error(error?.response?.data?.message);
            reject(error);
          }
        })
        .finally(() => {
          if (props.btnId) {
            WebService.removeLoader(props.btnId);
          }
        });
    });
  },
  getAPI(props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = { ...this.getHeaders(), ...props.headers };

      // ✅ Add default query params (timestamp)
      const queryParams = {
        // ...props.params, // custom params from caller
        timestamp: Date.now(), // default param
      };

      if (props.responseType === 'blob' || props.responseType === 'arraybuffer') {
        headers['Accept'] =
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      }

      if (props.btnId) {
        WebService.addLoader(props.btnId);
      }

      axios
        .get(`${BASE_URL}${props.action}`, {
          headers,
          params: queryParams, // ✅ IMPORTANT (this adds query params)
          responseType: props.responseType || 'json',
          signal: props.signal,
        })
        .then((response) => {
          if (
            props.responseType === 'arraybuffer' ||
            props.responseType === 'blob'
          ) {
            resolve(response);
          } else {
            resolve(response.data);
          }
        })
        .catch((error) => {
          if (axios.isCancel(error)) return;

          if (error?.response?.status === 401) {
            WebService.logout();
          }

          props.isShowError
            ? reject(error)
            : reject(WebService.errorHandler(error));
        })
        .finally(() => {
          if (props.btnId) {
            WebService.removeLoader(props.btnId);
          }
        });
    });
  },
  // getAPI(props: PropData) {
  //   return new Promise((resolve, reject) => {
  //     const headers = this.getHeaders();
  //     if (props.responseType === 'blob' || props.responseType === 'arraybuffer') {
  //       headers['Accept'] = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  //     }
  //     if (props.btnId) {
  //       WebService.addLoader(props.btnId);
  //     }

  //     axios
  //       .get(`${BASE_URL}${props.action}`, {
  //         headers,
  //         responseType: props.responseType || 'json', // ✅ allow 'blob' for downloads
  //       })
  //       .then((response) => {
  //         if (props.btnId) {
  //           WebService.removeLoader(props.btnId);
  //         }

  //         // ✅ If it's a file (blob), resolve the full response
  //         if (props.responseType === 'arraybuffer' || props.responseType === 'blob') {
  //           resolve(response); // send full response for file metadata
  //         } else {
  //           resolve(response.data);
  //         }
  //       })
  //       .catch((error) => {
  //         if (props.btnId) {
  //           WebService.removeLoader(props.btnId);
  //         }
  //         if (error?.response?.status === 401) {
  //           WebService.logout();
  //         }
  //         props.isShowError
  //           ? reject(error)
  //           : reject(WebService.errorHandler(error));
  //       });
  //   });
  // },
  deleteTokenAPI(props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = this.getHeaders();
      WebService.addLoader(props.btnId);
      axios.delete(`${BASE_URL}${props.action}`, { headers, data: props.body, signal: props.signal })
        .then((response) => resolve(response.data))
        .catch((error) => {
          if (axios.isCancel(error)) return;
          if (error?.response?.status === 401) {
            WebService.logout();
          }
          props.isShowError
            ? reject(error) : reject(WebService.errorHandler(error))
        })
        .finally(() => {
          if (props.btnId) {
            WebService.removeLoader(props.btnId);
          }
        });
    });
  },

  deleteAPI(props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = this.getHeaders();
      if (props.btnId) {
        WebService.addLoader(props.btnId);
      }
      axios.delete(`${BASE_URL}${props.action}`, { headers, signal: props.signal })
        .then((response) => resolve(response.data))
        .catch((error) => {
          if (axios.isCancel(error)) return;
          if (error?.response?.status === 401) {
            WebService.logout();
          }
          props.isShowError
            ? reject(error) : reject(WebService.errorHandler(error))
        });
    }).finally(() => {
      if (props.btnId) {
        WebService.removeLoader(props.btnId);
      }
    })
  },

  errorHandler(error: any) {
    if (error?.response) {
      error = error.response;
    }
    let errorMessage;
    if (!error || !error.status) {
      errorMessage = "Server Not Responding";
    } else if (error.status === 401) {
      errorMessage = "Unauthorized";
      WebService.logout();
    } else if (error.status === 500) {
      errorMessage =
        error?.data?.ErrorDetails?.message ||
        "An unknown exception has occurred. Please contact administrator";
    } else {
      errorMessage = error.data?.message || "Something went wrong";
    }
    const isGlobalIssue =
      !error?.status || error?.status >= 500 || error?.status === 0;

    if (isGlobalIssue) {
      if (!isGlobalErrorShown) {
        isGlobalErrorShown = true;
        // toast.error(errorMessage);
        HelperService.showSingleError(errorMessage);
        // reset after 5 seconds so new errors can show later
        globalErrorTimeout = setTimeout(() => {
          isGlobalErrorShown = false;
        }, 5000);
      }
    } else {
      // toast.error(errorMessage);
      HelperService.showSingleError(errorMessage);
    }
    return errorMessage;
  },


  addLoader(id?: string) {
    if (!id) return;

    const button = document.getElementById(id) as HTMLButtonElement | null;
    if (!button) return;

    button.disabled = true;
    button.style.position = "relative"; // make button the positioning context

    // Create loader wrapper
    const loader = document.createElement("span");
    loader.className = "button-loader";
    loader.innerHTML = `
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  `;

    // Style loader to center it
    Object.assign(loader.style, {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-70%, -70%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      pointerEvents: "none",
      color: '#931314'
    });

    button.appendChild(loader);
  },


  removeLoader(id: any) {
    if (!id) return;

    const button = document.getElementById(id) as HTMLButtonElement | null;
    if (!button) return;

    button.disabled = false;

    // Find the loader element we added
    const loader = button.querySelector(".button-loader");
    if (loader) {
      button.removeChild(loader);
    }
  },

  clearAuthSession() {
    const onboardingBackups: Record<string, string> = {};
    try {
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith("fx_onboarding_completed_")) {
          onboardingBackups[key] = localStorage.getItem(key) || "";
        }
      }
    } catch (e) {
      console.error("Error backing up onboarding progress:", e);
    }

    localStorage.clear();
    sessionStorage.clear();

    try {
      Object.entries(onboardingBackups).forEach(([key, value]) => {
        localStorage.setItem(key, value);
      });
    } catch (e) {
      console.error("Error restoring onboarding progress:", e);
    }
  },

  logout() {
    this.clearAuthSession();
    sessionStorage.clear();
    store.dispatch({ type: 'LOGOUT' });
    setTimeout(() => {
      window.location.href = "/login";
    }, 500);
  },
  getBaseUrl() {
    return BASE_URL;
  },
  getHeaders(): Record<string, string> {
    return {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("access_token"),
      outletid: localStorage.getItem("outlet_id") || '',
      clientid: localStorage.getItem("client_id") || '',
      "Cache-Control": "no-cache, no-store, must-revalidate",
      Pragma: "no-cache",
      Expires: "0",
    };
  },
  getMultipartHeaders() {
    const headers = {
      // "Content-Type": "application/x-www-form-urlencoded",
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + sessionStorage.getItem("access_token"),
      outletid: localStorage.getItem("outlet_id") || '',
      clientid: localStorage.getItem("client_id") || '',
      "Cache-Control": "no-cache, no-store, must-revalidate",
      Pragma: "no-cache",
      Expires: "0",
    };
    return headers;
  },
};

export default WebService;
